import axios from 'axios'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    fetchStaticView(ctx, slug) {
      return axios({
        method: 'POST',
        url: `api/v3/common/${slug}/view/`,
      }).catch((error) => {
        console.error(error)
      })
    },
  },
}
